import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from '@edx/frontend-platform/i18n';
import { Alert } from '@edx/paragon';
import { Info } from '@edx/paragon/icons';

import { useModel } from '../../../../generic/model-store';

import messages from './messages';

function GatedLock({ sequenceId, intl }) {
  const sequence = useModel('sequences', sequenceId);

  return (
    <Alert variant="info" icon={Info}>
      <h3>{intl.formatMessage(messages.header)}</h3>
      <p>
        {sequence.minGrade && (
          <>
            <br />
            <FormattedMessage
              id="learn.gatedLock.description"
              defaultMessage="To access this content you have to get at least {number}% grade for the course."
              values={{
                number: sequence.minGrade,
              }}
            />
          </>
        )}
      </p>
    </Alert>
  );
}

GatedLock.propTypes = {
  intl: intlShape.isRequired,
  sequenceId: PropTypes.string.isRequired,
};

export default injectIntl(GatedLock);
